import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import type { ProductRoute } from "../app/product-router.js";
import { useAdminView } from "./admin-view-provider.js";
import type { AdminViewMode } from "../app/admin-view-choice.js";
import "../styles/admin-view.css";

export function AdminViewChoice({
  route,
}: {
  route: ProductRoute;
}): React.JSX.Element | null {
  const view = useAdminView();
  if (!view.canChoose) return null;
  const select = (mode: AdminViewMode) => {
    view.select(mode);
    if (mode === "admin") route.navigate("admin");
    else if (route.page === "admin") route.navigate("clubhouse");
  };
  return (
    <Dialog
      open={view.needsChoice || view.choosing}
      onOpenChange={(open) => {
        if (!open) select("player");
      }}
    >
      <DialogContent
        className="fr-admin-view-dialog fr-more-dialog"
        overlayClassName="fr-dialog-veil"
        showCloseButton={false}
      >
        <DialogTitle className="fr-h2">Your view</DialogTitle>
        <DialogDescription>
          Switch between playing and managing the app.
        </DialogDescription>
        <button
          className="fr-admin-view-option"
          type="button"
          aria-pressed={view.mode === "player"}
          onClick={() => select("player")}
        >
          <strong>Player view</strong>
          <span>Rounds and rivals</span>
        </button>
        <button
          className="fr-admin-view-option"
          type="button"
          aria-pressed={view.mode === "admin"}
          onClick={() => select("admin")}
        >
          <strong>Admin view</strong>
          <span>Reviews, reports and activity</span>
        </button>
      </DialogContent>
    </Dialog>
  );
}

export function AdminViewSwitcher(): React.JSX.Element | null {
  const view = useAdminView();
  if (!view.canChoose) return null;
  return (
    <div className="fr-admin-view-switch">
      <span>
        <strong>{view.mode === "admin" ? "Admin view" : "Player view"}</strong>
        <small>Your current app view</small>
      </span>
      <button type="button" className="fr-btn" onClick={view.openChoice}>
        Change view
      </button>
    </div>
  );
}

export function AdminViewRouteGate(): React.JSX.Element {
  const view = useAdminView();
  return (
    <section className="fr-admin-view-gate">
      <h1 className="fr-h2">
        {view.canChoose
          ? "You’re in Player view."
          : "This page is unavailable."}
      </h1>
      {view.canChoose ? (
        <>
          <p>Switch to Admin view to open the admin tools.</p>
          <button type="button" className="fr-btn" onClick={view.openChoice}>
            Change view
          </button>
        </>
      ) : null}
    </section>
  );
}
